

































































import Vue from "vue";
import Component from "vue-class-component";

import { Deck, Event, NavBarConfigItem } from '../../types';
import navBarConfigJson from './navbar.json';

import * as selectedDeckDialogHelper from "../../helpers/selectedDeckDialogHelper";

const NavigationBarProps = Vue.extend({
  props: {
    title: String,
    decks: {type: Array as () => Deck[]},
    numberOfSelectedDecks: Number,
  }
});

@Component
export default class NavigationBar extends NavigationBarProps {
  primaryDrawer = {
    model: false,
    type: "temporary",
    clipped: true,
    floating: false,
    mini: false
  };
  navBarList = navBarConfigJson as NavBarConfigItem[];

  get isInDeckSelection() {
    return this.$route.name === "DeckSelection";
  }
  get isInLearning() {
    return this.$route.name === "Learn";
  }
  get colorAppBar() {
    if (this.isInDeckSelection && this.numberOfSelectedDecks > 0) {
      return "indigo";
    }
    return "";
  }
  get toolbarTitle() {
    if (this.isInDeckSelection && this.numberOfSelectedDecks > 0) {
      return `${this.numberOfSelectedDecks} deck${
        this.numberOfSelectedDecks === 1 ? "" : "s"
      } selected`;
    }
    return this.title;
  }

  deselectAll() {
    this.$eventHub.$emit(Event.DESELECT_ALL_DECKS);
  }
  selectAll() {
    this.$eventHub.$emit(Event.SELECT_ALL_DECKS);
  }
  deleteSelected() {
    selectedDeckDialogHelper.deleteSelected(this);
  }
  showInfoForSelectedDeck() {
    selectedDeckDialogHelper.showInfoForSelectedDeck(this);
  }
  showDrawer() {
    this.primaryDrawer.model = true;
  }
  hideDrawer() {
    this.primaryDrawer.model = false;
  }
  quitLearning() {
    this.$eventHub.$emit(Event.PREPARE_QUIT_LEARNING);
  }
  togglePrimaryDrawer() {
    this.primaryDrawer.model = !this.primaryDrawer.model;
  }
}
